'use strict';

/**
 * @public prefillQuestions
 * @description
 * Will prefill questions if an answer is available
 */
function prefillQuestions() {
    if (this.targetStepId in this.givenAnswers && this.targetStep) {
        this.currentStepInput = this.targetStep.querySelector(this.selectors.stepInput);

        if (this.currentStepInput && this.givenAnswers[this.targetStepId] !== this.values.skipped) {
            this.currentStepInput.value = this.givenAnswers[this.targetStepId];
        }
    }
}

export { prefillQuestions };
